<template>
  <div class="main">
    <a
      :href="appStoreUrl"
      target="_blank"
      @click.prevent="redirectToAppStore"
    >
      <img
        src="../../assets/images/ios/appStoreLogo.svg"
        alt="App Store"
        class="app-logo"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'iOS',
  data() {
    return {
      appStoreUrl: 'https://apps.apple.com/ru/app/multiping-vpn-proxy/id6747254639',
    }
  },
  methods: {
    redirectToAppStore() {
      window.open(this.appStoreUrl, '_blank')
    }
  }
}
</script>

<style scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.app-logo {
  margin-left: 20px;
  width: 200px; 
  max-width: 80%; 
  height: auto; 
}
</style>
